



































































import Vue from 'vue';
import { Dictionary } from 'vuex';
import AsModal from '@/components/Ui/AsModal.vue';
import AsCollapse from '@/components/Ui/AsCollapse.vue';
import settingsHelper from '@/store/modules/settings/helper';
const settingsHelpers = settingsHelper.mapGetters(['client', 'textOverrides']);

export default Vue.extend({
  name: 'FAQ',
  components: {
    AsModal,
    AsCollapse,
  },
  computed: {
    ...settingsHelpers,
    overrides(): Dictionary<string> {
      return this.textOverrides.faq || {};
    },
    bankUnavailable(): string {
      return this.overrides.bankUnavailable !== undefined
        ? this.overrides.bankUnavailable
        : `Not all banks in the UK support Open Banking. If you cannot see your bank or building society listed, we recommend you contact ${this.client} to ask for an alternative method to share your bank transactions with them.`;
    },
  },
});
